<script setup>
const props = defineProps({
  title: String,
  icon: String,
  value: String,
  submenu: Array
});
const isGroup = props.submenu?true:false
</script>
<template>
  <v-list-group v-if="isGroup">
    <template v-slot:activator="slotProps">
      <list-item-menu v-bind="slotProps.props" :icon="props.icon" :title="props.title" :value="props.value"></list-item-menu>
    </template>
    <list-item-menu v-for="(submenu, j) in props.submenu" :key="j" v-bind="submenu" />
  </v-list-group>
  <v-list-item v-else class="pa-0">
    <v-list-item-avatar>
      <v-icon :icon="props.icon"></v-icon>
    </v-list-item-avatar>
    <v-list-item-title v-text="props.title"></v-list-item-title>
  </v-list-item>
</template>